export default function EntitlementSummary() {
    return <div>EntitlementSummary</div>
}
